
import { useContext } from 'react';

import { Breakpoint } from '@rta/rta-blueprint-library';

import { AppContext } from '@r-app/app-context';
import { RenderBreakpoint } from './render-breakpoint';
import { renderTracking } from '@r-services/render-tracking';

export type RenderBreakpointsCountertopProps = {
	islandId: string;
	panelId?: string;
}

export const RenderBreakpointsCountertop = (params: RenderBreakpointsCountertopProps): React.ReactElement => {
	const { islandId, panelId = null } = params;
	const { controller: { kitchen }} = useContext(AppContext);

	const island = kitchen.design.islands.findById(islandId);

	// only renedr top, front and back views
	if (panelId !== null && island.panels.findById(panelId).isSidePanel) return null;

	const [backPanel] = island.panels.getBackPanels();
	const [countertop] = kitchen.design.countertops.filterByIslandId(islandId);

	const jsxBreakpoints: Array<React.ReactElement> = [];
	const xOffset = 0;
	const yOffset = panelId
		? -countertop.material.thickness
		: countertop.center.z;
	const height = panelId
		? countertop.material.thickness
		: island.islandSize.depth + island.frontPanel.countertopOverhang + backPanel.countertopOverhang;

	// render panel breakpoints
	countertop.breakpoints.children.forEach((breakpoint) => {
		const xBreakpoint = xOffset + breakpoint.center;
		jsxBreakpoints.push(<RenderBreakpoint key={breakpoint.id} {...{
			breakpoint: breakpoint as Breakpoint,
			center: { x: xBreakpoint, y: yOffset },
			height
		}}></RenderBreakpoint>)
	});

	renderTracking.incrementRender('RenderBreakpointsCountertop');
	return <>{jsxBreakpoints}</>;
};
